import { render, staticRenderFns } from "./formProvider.vue?vue&type=template&id=24a91808"
import script from "./formProvider.vue?vue&type=script&lang=js"
export * from "./formProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports